import axios from 'axios'
import _ from 'lodash'
import { CHAINCODE_MARRIOTT_BRANDS,CHAINCODE_HILTON_BRANDS,CHAINCODE_HYATT_BRANDS,CHAINCODE_ALL_BRANDS,SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

const headers = {'Content-Type': 'application/json'}

export function getInvFacetDataDefaultFromServer(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For favHotelsNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(getInvFacetHotelsBegin())

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/facetFilterhotels`
        //const url = 'http://localhost:8080/essearch/facetFilterhotels'
      
          
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                if(r.data.facetData){
                   
                    const comData = r.data.facetData
                   
                   
                    let newfacetData = { facetData : comData}
                    dispatch(getInvFacetHotelsSuccess(newfacetData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getInvFacetHotelsSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getInvFacetHotelsError(e))
        )
    }

}

export const getInvFacetHotelsBegin = () => dispatch => {
    dispatch({
        type:"invfacet/SOJOURNS_BEGIN"
        
    })
}

export const getInvFacetHotelsSuccess = (data) => dispatch => {
   
     dispatch({
        type: "invfacet/SOJOURNS_SUCCESS",
        payload: data
    })

   
}



export const getInvFacetHotelsError = (e) =>dispatch => {
    dispatch({
        type:"invfacet/SOJOURNS_ERROR",
        error:e
    })
}

export const saveInvFacetFilterCheckSuccess = (data) => dispatch => {
    console.log('sv*********saveInvFacetFilterCheckSuccess  start')
    console.log(data)
    console.log('sv*********saveInvFacetFilterCheckSuccess  end')
    let comData = {
        chaincode :'marriott',

        rbBrand1Label : CHAINCODE_ALL_BRANDS,
                rbBrand2Label : CHAINCODE_MARRIOTT_BRANDS,
                rbBrand3Label:CHAINCODE_HILTON_BRANDS,
                rbBrand4Label:CHAINCODE_HYATT_BRANDS,
        
        "checkedLmDisneyLabel":'Disaney Springs',
        "checkedLmDisney":true,
        "disabledLmDisney":false,

        //svjun7 start
        checkedLmDisneyLabel:'Jet ski',
        checkedLmDisney:true,
        disabledLmDisney:false,

        checkedLmGolfLabel:'Golf',
        checkedLmGolf:true,
        disabledLmGolf:false,
        //svjun7 end
         //svst start
         checkedStFiveLabel:'5 Stars',
         checkedStFive:true,
         disabledStFive:false,

         checkedStFourLabel:'4 Stars',
         checkedStFour:true,
         disabledStFour:false,

         checkedStThreeLabel:'3 Stars',
         checkedStThree:true,
         disabledStThree:false,

         checkedStTwoLabel:'2 Stars',
         checkedStTwo:true,
         disabledStTwo:false,
 

         //svst end
        //svrs okay
        checkedRsExcellentLabel:'9+  Excellent',
        checkedRsExcellent:true,
        disabledRsExcellent:false,


        checkedRsGreatLabel:'8+ Great',
        checkedRsGreat:true,
        disabledRsGreat:false,

        checkedRsGoodLabel:'7+  Good',
        checkedRsGood:true,
        disabledRsGood:false,

        checkedRsOkayLabel:'5+ Okay',
        checkedRsOkay:true,
        disabledRsOkay:false,


        //svrs end
        //svfb start


        checkedRtp1Label:"DBL.2D-NM",
        checkedRtp1:true,
        disabledRtp1:false,


        checkedRtp2Label:"DBL.2Q-2",
        checkedRtp2:true,
        disabledRtp2:false,

        checkedRtp3Label:"DBL.2D-SU",
        checkedRtp3:true,
        disabledRtp3:false,

        checkedRtp4Label:"DBL.2Q-1",
        checkedRtp4:true,
        disabledRtp4:false,

        checkedRtp5Label:"DBL.2D-EJ",
        checkedRtp5:true,
        disabledRtp5:false,

        checkedRtp6Label:"DBL.2D-SU",
        checkedRtp6:true,
        disabledRtp6:false,

        checkedRtp7Label: "DBL.2Q-EJ",
        checkedRtp7:true,
        disabledRtp7:false,

        checkedRtp8Label:"DBL.DX",
        checkedRtp8:true,
        disabledRtp8:false,

        //sj sgl
        checkedRtp9Label:"SGL.EJ",
        checkedRtp9:true,
        disabledRtp9:false,

        checkedRtp10Label:"SGL.H6",
        checkedRtp10:true,
        disabledRtp10:false,

        checkedRtp11Label: "SUI.2D",
        checkedRtp11:true,
        disabledRtp11:false,

        checkedRtp12Label:"SUI.2K",
        checkedRtp12:true,
        disabledRtp12:false,

        checkedRtp13Label:"SUI.65",
        checkedRtp13:true,
        disabledRtp13:false,

        
        checkedFbCancellationLabel:'2 DOUBLE BED',
        checkedFbCancellation:true,
        disabledFbCancellation:false,

        checkedFbInternetLabel:'1 DOUBLE BED',
        checkedFbInternet:true,
        disabledFbInternet:false,

        checkedFbParkingLabel:'1 ROOM',
        checkedFbParking:true,
        disabledFbParking:false,

        checkedFbBreakfastLabel:'1 SINGLE BED',
        checkedFbBreakfast:true,
        disabledFbBreakfast:false,

        //svfb end
        

        "minBudgetPrice":20,
        "maxBudgetPrice":800,
        "valueSlider":100,
        
        "checkedParkingLabel":"Parking",
        "checkedParking":true,
        "disabledParking":false,

        "checkedWifiLabel":"Wifi",
        "checkedWifi":true,
        "disabledWifi":false,

        "checkedRestaurantLabel":"Restaurant",
        "checkedRestaurant":true,
        "disabledRestaurant":false,

        "checkedPetfriendlyabel":"pet Friendlly",
        "checkedPetfriendly":true,
        "disabledPetfriendly":false,

        "checkedRoomserviceLabel":"Room Service",
        "checkedRoomservice":true,
        "disabledRoomservice":false,

        "checkedFrontdeskLabel":"24 Hours Front Desk",
        "checkedFrontdesk":true,
        "disabledFrontdesk":false,

        "checkedFitnessLabel":"Fitness Center",
        "checkedFitness":true,
        "disabledFitness":false,

        "checkedNonsmokingLabel":"Non Smoking",
        "checkedNonsmoking":true,
        "disabledNonsmoking":false,

        "checkedShuttleLabel":"Airport Shuttle",
        "checkedShuttle":true,
        "disabledShuttle":false,

        "checkedFamilyroomsLabel":"Family Room",
        "checkedFamilyrooms":true,
        "disabledFamilyrooms":false,

        "checkedSpaLabel":"Spa",
        "checkedSpa":true,
        "disabledSpa":false,

        "checkedEvchargingLabel":"Electric Vehicle(EV) Charging",
        "checkedEvcharging":true,
        "disabledEvcharging":false,

        "checkedWheelchairLabel":"Wheel Chair Accessibility",
        "checkedWheelchair":true,
        "disabledFWheelchair":false

      
    }
    let newfacetData = { facetData : data.facetData, svfacet_myloc:data.svfacet_myloc}
    dispatch(getInvFacetHotelsSuccess(newfacetData))
/*
    dispatch({
        type: "invfacet/SOJOURNS_SUCCESS",
        payload: data
    })
    */
}